import MAComplianceStatsPage from './MAComplianceStatsPage'

export { MAComplianceStatsPage }
export default MAComplianceStatsPage
